<div [attr.data-Id]="customElementId">
    <p [innerHTML]="getQuestionText()"> </p>
</div>